const amountNumberFormat = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/**
 * 格式化金额
 * @param amount 金额
 * @returns 格式化后的金额
 */
export const formatAmount = (amount: number) => {
  return amountNumberFormat.format(amount)
}
